var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row mt-2 row-container" }, [
    _c("div", { staticClass: "col-2 col-sm col-12 border-right status" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6 col-md-12" },
          [
            _c("custom-balloon", {
              staticClass:
                "w-md-80 w-90 mt-2 mx-md-3 font-weight-normal font-16",
              attrs: {
                "background-color": _vm.getColor(_vm.value.monitoringStatusId),
                text: _vm.value.status
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-5 col-md-0 d-block d-md-none" }, [
          _c("div", { staticClass: "label" }, [_vm._v(" Número: ")]),
          _c("span", { staticClass: "info" }, [
            _vm._v(" " + _vm._s(_vm.value.monitoringNo) + " ")
          ])
        ])
      ])
    ]),
    _c(
      "div",
      {
        staticClass:
          "col-3 col-sm col-12 pl-md-3 pl-md-4 pl-sm-4 mt-4 mt-md-0 mt-sm-4 pt-md-3 d-none d-md-block"
      },
      [
        _c("div", { staticClass: "label" }, [_vm._v("Número:")]),
        _c("span", { staticClass: "info" }, [
          _vm._v(" " + _vm._s(_vm.value.monitoringNo) + " ")
        ])
      ]
    ),
    _c("div", { staticClass: "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-3" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Fecha:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.date)) + " ")
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-md-3" },
      [
        _c("div", { staticClass: "label" }, [_vm._v("Hallazgo:")]),
        _c("span", { staticClass: "info" }, [
          _vm._v(" " + _vm._s(_vm.value.finding) + " ")
        ])
      ]
    ),
    _c(
      "div",
      {
        staticClass: "col-12 col-md-2 text-center mt-4 mt-md-0 pr-md-5 pt-md-3"
      },
      [
        _c("drop-down", {
          staticClass: "actions-dropdown",
          attrs: {
            "data-item": { value: _vm.value, index: _vm.index },
            items: _vm.actionItems
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }